import React, { useEffect, useState } from "react";
import logo from '../assets/logo.png';

export default function AppPaymentFail() {
    const [lang, setLang] = useState("fr"); // default French

    const content = {
        fr: {
            title: "Paiement impossible",
            message: "VNous n'avons pas pu finaliser votre paiement, mais rassurez-vous, aucun montant n'a été débité.",
            sub: "Vous n'avez pas été redirigé(e) automatiquement ?",
            btn: "Cliquez ici pour retourner sur l'application Diaba",
        },
        en: {
            title: "Payment Failed",
            message: "We couldn’t complete your payment, but don’t worry—no amount was deducted.",
            sub: "Not redirected automatically?",
            btn: "Click here to return to the Diaba app",
        },
    };


    const openApp = () => {
        // const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        // if (isIOS) {
        window.location.href = "diaba://payment-failed";
        // } else {
        //     const intentUrl =
        //         "intent://payment-success#Intent;scheme=diaba;package=com.diaba.ecommerce;end;";
        //     window.location.href = intentUrl;
        // }
    };


    useEffect(() => {
        openApp()
    }, [])

    const t = content[lang];

    return (
        <div className="failed-payment-wrapper">
            <div className="failed-payment-card">
                <div className="failed-lang-switch">
                    <button
                        className={lang === "fr" ? "failed-active" : ""}
                        onClick={() => setLang("fr")}
                    >
                        FR
                    </button>
                    <button
                        className={lang === "en" ? "failed-active" : ""}
                        onClick={() => setLang("en")}
                    >
                        EN
                    </button>
                </div>

                {/* <img
                    src={logo}
                    alt="Logo"
                    className="failed-logo"
                /> */}

                <div className="failed-success-icon">X</div>

                <h1>{t.title}</h1>
                <p className="failed-main-text">{t.message}</p>
                <p className="failed-sub-text">{t.sub}</p>

                <button className="failed-home-btn" onClick={openApp}>{t.btn}</button>
            </div>
        </div>
    );
}
